class CountTaskModel {
    constructor({ un_assigned_count = null, assigned_count = null, completed_count = null } = {}) {
        this.unAssignedCount = un_assigned_count;
        this.assignedCount = assigned_count;
        this.completedCount = completed_count;
    }

    static fromJson(json) {
        return new CountTaskModel({
            un_assigned_count: json.un_assigned_count,
            assigned_count: json.assigned_count,
            completed_count: json.completed_count,
        });
    }

    toJson() {
        return {
            un_assigned_count: this.unAssignedCount,
            assigned_count: this.assignedCount,
            completed_count: this.completedCount,
        };
    }
}
export {CountTaskModel};